import {
  PhoneNumberProvider,
  ProviderTransitionType,
} from "@redotech/redo-model/phone/phone-number";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const startProviderTransition = {
  name: "startProviderTransition" as const,
  input: z.object({
    phoneNumberId: zExt.objectId(),
    toProvider: z.enum(PhoneNumberProvider),
    transitionType: z.enum(ProviderTransitionType).optional(),
  }),
  output: z.object({ success: z.boolean() }),
};

export type StartProviderTransitionInput = z.infer<
  typeof startProviderTransition.input
>;
export type StartProviderTransitionOutput = z.infer<
  typeof startProviderTransition.output
>;
